//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Topic, Quiz } from "@/models";
import XczFooter from '@/components/footer/footer'

export default {
  name: "kebenGame",
  created() {
    this.$initWechat().then(() => {
      this.$initWechatShare({
        // title: "中国诗词数据库 · 西窗烛",
        title: "诗词接龙、飞花令、诗词大会",
        link: location.href,
        // image: "http://ac-9pq709je.clouddn.com/bda4f64984c2dba80105.png",
        image: "http://bigfile.xichuangzhu.com/logo.png",
        // desc: "品味中国诗词之美"
        desc: "中华古诗词数据库"
      });
    });

    Topic.getJielongTopics(1, 3).then(jielongs => {
      this.jielongs = jielongs;
    });

    Topic.getFeihuaTopics(1, 3).then(feihuas => {
      this.feihuas = feihuas;
    });

    // Quiz.getAllForTest(1, 2).then(quizs => {
    Quiz.getAll(1, 3).then(quizs => {
      this.quizs = quizs;
    });
  },
  props: [],
  data() {
    return {
      jielongs: [],
      feihuas: [],
      quizs: []
    };
  },
  metaInfo() {
    return {
      title: "比赛 - 中华诗词库",
      titleTemplate: null
    };
  },
  methods: {
    goToJielong: function(jielong) {
      this.$router.push({ name: "topic", params: { id: jielong.id } });
    },

    moreJielong: function() {
      this.$router.push({ name: "jielongs" });
    },

    goToFeihua: function(feihua) {
      this.$router.push({ name: "topic", params: { id: feihua.id } });
    },

    moreFeihua: function() {
      this.$router.push({ name: "feihuas" });
    },

    goToQuiz: function(quiz) {
      this.$router.push({ name: "quiz", params: { id: quiz.id } });
    },

    moreQuiz: function() {
      this.$router.push({ name: "quizs" });
    }
  },
  components: {
    XczFooter,
  }
};



// WEBPACK FOOTER //
// ./src/pages/layouts/keben-pages/Game.vue